import { createI18n } from 'vue-i18n'
import { getBrowserLanguage, getCookieValue } from '.'
import { Token } from './constants'

const messages = {
    en: {
        lang: {
            zh: '简体中文',
            en: 'English',
            kor: '한국어'
        },
        languagegialog: {
            title: 'Language'
        },
        common: {
            confirm: 'Confirm',
            cancel: 'Cancel',
            allgames: 'All Games',
            baccarat: 'Baccarat',
            dragontiger: 'Dragon Tiger',
            search: 'Search',
            norecordfound: 'No Record Found',
            livegames: 'Live Games',
            video: 'Video',
            enterthistable: 'GO PLAY',
            fullscreen: 'Full Screen',
            lobby: 'Loby',
            goodroadsort: 'Good Road Sort',
            tablesort: 'Table Sort'
        },
        login: {
            username: 'Username',
            password: 'Password',
            code: 'Verify Code',
            login: 'Login',
            trial: 'Trial',
            usernameplaceholder: 'Please enter your username',
            passwordplaceholder: 'Enter your password'
        },
        tables: {
            startgame: 'Play',
            selectlimit: 'SELECT',
            limit: 'Table Limit',
            youatthistable: 'You are at this table',
            multibet: 'Multi Tables'
        },
        desk: {
            startbet: 'START BET',
            nobet: 'STOP BET',
            shoe: 'Shoe',
            limit: 'Limit',
            latestnews: 'Latest News',
            servicehotline: 'Service Hotline',
            gamenumber: 'Game No.'
        },
        setting: {
            betrecord: 'Bet Records',
            rule: 'Game Rules',
            changepassword: 'Change Password',
            customerservice: 'Customer Service',
            soundeffect: 'Sound',
            signout: 'Sign out'
        },
        changepassword: {
            oldpassword: 'Old password',
            newpassword: 'New password',
            confirmpassword: 'Confirm password'
        },
        serverselection: {
            lineSelection: 'Line Selection',
            p1: 'Line is green',
            p2: 'You can click directly to enter. Red',
            p3: 'Indicates that the line is unavailable,',
            p4:
                'If all three lines are unavailable, please contact online customer service to obtain more lines, enter the obtained line address and click to enter the game. I wish you a happy game.',
            line1: 'Line1',
            line2: 'Line2',
            line3: 'Line3',
            customline: 'Custom Lines',
            enter: 'Enter',
            lineerror: 'IP is invalid'
        },
        securitynotice: {
            brand: 'Global 360',
            title: 'Security Notice',
            intro:
                'Fraudsters have recently been found misusing our company information, copying platform domains, creating phishing websites and fake customer-service staff, stealing member passwords, and defrauding members of their funds. Please stay alert and confirm the official domain.',
            introWarning:
                'Using a website on an unofficial domain may cause financial loss. The company will not be responsible!',
            accountsTitle: 'Official iChat Support',
            accountPlatform: 'Official iChat account',
            accountBadge: 'Official support',
            accountName: 'Global 360 Senior VIP Support',
            serviceWarning:
                'All Global 360 support staff use iChat only. Any support using other chat software is fake!',
            verifyTitle: 'Official Domain Check',
            verifyHint:
                'Open the verification platform and enter or paste the website you are using to check whether it is an official domain.',
            verifyPlatform: 'Verification platform',
            finalWarning:
                'Using a fake website may lead to account theft or financial loss. The company will not be responsible!',
            verifyNow: 'Verify now',
            close: 'Close',
            closeCountdown: 'Close ({n}s)'
        },
        prompt: {
            networkerror: 'The current network is not good, please try again',
            networkoffline: 'No network connection',
            networkreconnecting: 'Connection lost, reconnecting...',
            networkrecovered: 'Network restored',
            sessionexpired: 'Session has expired',
            wsrelogin:
                'Network connection is abnormal, please log in to the system again, thank you!',
            inactive:
                'You have been inactive for a while, please log in again to continue playing',

            // betting  prompt
            // d7error: 'Dragon 7 cannot be bet after 35 rounds',
            // b8error: 'Bear 8 cannot be bet after 35 rounds',
            // bigtigererror: 'Big Tiger cannot be bet after 50 rounds',
            // smalltigererror: 'Small Tiger cannot be bet after 50 rounds'
            d7error: '35局以后不可下注龙7',
            b8error: '35局以后不可下注熊8',
            bigtigererror: '35局以后不可下注大老虎',
            smalltigererror: '35局以后不可下注小老虎'
        }
    },
    zh: {
        lang: {
            zh: '简体中文',
            en: 'English',
            kor: '한국어'
        },
        languagegialog: {
            title: '语言设置'
        },
        common: {
            confirm: '确 认',
            cancel: '取消',
            allgames: '全部游戏',
            baccarat: '百家乐',
            dragontiger: '龙虎',
            search: '查询',
            norecordfound: ' 没有查询到记录',
            livegames: '现场游戏',
            video: '视频',
            enterthistable: '进入此桌',
            fullscreen: '全屏幕',
            lobby: '返回大厅',
            goodroadsort: '好路排序',
            tablesort: '桌台排序'
        },
        login: {
            username: '用户名称',
            password: '密码',
            code: '验证码',
            login: '登 入',
            trial: '试玩',
            usernameplaceholder: '请输入您的用户名',
            passwordplaceholder: '输入您的密码'
        },
        tables: {
            startgame: '开始游戏',
            selectlimit: '选择限红',
            limit: '限红',
            youatthistable: '您在此桌',
            multibet: '自选多合一'
        },
        desk: {
            startbet: '开始接受投注',
            nobet: '停止投注',
            shoe: '靴局',
            limit: '限红',
            latestnews: '最新消息',
            servicehotline: '服务热线',
            gamenumber: '游戏编号'
        },
        setting: {
            betrecord: '游戏记录',
            rule: '游戏规则',
            changepassword: '修改密码',
            customerservice: '线上客服',
            soundeffect: '声音效果',
            signout: '登出'
        },
        changepassword: {
            oldpassword: '原始密码',
            newpassword: '新密码',
            confirmpassword: '确认密码'
        },
        serverselection: {
            lineSelection: '线路选择',
            p1: '线路为绿色',
            p2: '可直接点击进入，红色',
            p3: '代表该线路不可用，',
            p4:
                '如三个线路均不可用，请联系在线客服获取更多线路，并输入所获取的线路地址点击进入，即可游戏，祝您游戏愉快。',
            line1: '线路一',
            line2: '线路二',
            line3: '线路三',
            customline: '自定义线路',
            enter: '进入',
            lineerror: 'ip 地址错误'
        },
        securitynotice: {
            brand: '环球360',
            title: '安全提醒',
            intro:
                '近期发现有诈骗分子擅自使用我司资料，仿制平台域名、制作钓鱼网站及虚假客服人员，盗取会员账号密码，骗取会员资金。请所有会员提高警惕，确认官方域名。',
            introWarning: '使用非官方域名的网址，造成资金损失，公司概不负责！',
            accountsTitle: '官方I聊客服',
            accountPlatform: '官方 i聊账号',
            accountBadge: '官方客服',
            accountName: '环球360高级VIP客服',
            serviceWarning:
                '环球360旗下所有客服人员只使用i聊，任何使用其他聊天软件的客服均为假冒！',
            verifyTitle: '官方域名验证',
            verifyHint:
                '打开验证平台，将您正在使用的网址，输入或复制粘贴到验证平台中核查，即可查看当前使用网址是否为官方域名。',
            verifyPlatform: '验证平台',
            finalWarning: '使用假网造成账号被盗或资金损失，公司概不负责！',
            verifyNow: '马上验证',
            close: '关闭',
            closeCountdown: '关闭 ( {n}s )'
        },
        prompt: {
            networkerror: '当前网络不佳，请重新尝试',
            networkoffline: '当前无网络连接',
            networkreconnecting: '连接已断开，正在重新连接...',
            networkrecovered: '网络已恢复',
            sessionexpired: '会话已过期',
            wsrelogin: '网络连接异常，请您重新登录系统，谢谢！',
            inactive: '长时间未操作，自动退出，请重新登陆',
            // betting  prompt
            d7error: '35局以后不可下注龙7',
            b8error: '35局以后不可下注熊8',
            bigtigererror: '35局以后不可下注大老虎',
            smalltigererror: '35局以后不可下注小老虎'
        }
    },
    kor: {
        lang: {
            zh: '简体中文',
            en: 'English',
            kor: '한국어'
        },
        languagegialog: {
            title: '언어 설정'
        },
        common: {
            confirm: '확인하다',
            cancel: '취소',
            allgames: '모든 게임들',
            baccarat: '바카라',
            dragontiger: '드래곤 타이거',
            search: '찾다',
            norecordfound: '기록을 찾을 수 없습니다',
            livegames: '라이브 게임',
            video: '동영상',
            enterthistable: '놀다',
            fullscreen: '전체 화면',
            lobby: '로비',
            goodroadsort: '호로 정렬',
            tablesort: '테이블 정렬'
        },
        login: {
            username: '사용자 이름',
            password: '비밀번호',
            code: '코드 확인',
            login: '로그인',
            trial: '재판',
            usernameplaceholder: '사용자 이름을 입력하세요',
            passwordplaceholder: '비밀번호를 입력하세요'
        },
        tables: {
            startgame: '놀다',
            selectlimit: '선택하다',
            limit: '테이블 한도',
            youatthistable: '당신은 이 테이블에 있습니다',
            multibet: '멀티 테이블'
        },
        desk: {
            startbet: '베팅 시작',
            nobet: '베팅 중지',
            shoe: '구두',
            limit: '한계',
            latestnews: '최근 뉴스',
            servicehotline: '서비스 핫라인',
            gamenumber: '게임 번호'
        },
        setting: {
            betrecord: '베팅 기록',
            rule: '게임 규칙',
            changepassword: '비밀번호 변경',
            customerservice: '고객 서비스',
            soundeffect: '음향 효과',
            signout: '로그아웃'
        },
        changepassword: {
            oldpassword: '기존 비밀번호',
            newpassword: '새 비밀번호',
            confirmpassword: '비밀번호 확인'
        },
        serverselection: {
            lineSelection: '라인 선택',
            p1: '선이 녹색입니다',
            p2: '클릭하면 바로 들어갈 수 있습니다, 빨간색',
            p3: '회선을 사용할 수 없음을 나타냅니다.',
            p4:
                '세 라인을 모두 사용할 수 없는 경우 온라인 고객 서비스에 문의하여 더 많은 라인을 확보하고 획득한 라인 주소를 입력한 후 클릭하여 게임에 입장하시기 바랍니다. ',
            line1: '1번째 줄',
            line2: '라인 2',
            line3: '3번째 줄',
            customline: '맞춤 라인',
            입력하다: '입력하다',
            lineerror: 'IP 주소 오류'
        },
        securitynotice: {
            brand: '글로벌360',
            title: '보안 안내',
            intro:
                '최근 사기범이 당사 자료를 무단으로 사용하여 플랫폼 도메인을 위조하고, 피싱 사이트와 가짜 고객센터를 만들어 회원 비밀번호를 탈취하고 자금을 편취하는 사례가 발견되었습니다. 모든 회원님은 각별히 주의하시고 공식 도메인을 확인해 주십시오.',
            introWarning:
                '비공식 도메인의 웹사이트를 이용하면 자금 손실이 발생할 수 있으며, 회사는 책임을 지지 않습니다!',
            accountsTitle: '공식 iChat 고객센터',
            accountPlatform: '공식 iChat 계정',
            accountBadge: '공식 고객센터',
            accountName: '글로벌360 고급 VIP 고객센터',
            serviceWarning:
                '글로벌360 소속 고객센터 직원은 iChat만 사용합니다. 다른 채팅 프로그램을 사용하는 고객센터는 모두 사칭입니다!',
            verifyTitle: '공식 도메인 확인',
            verifyHint:
                '확인 플랫폼을 열고 현재 사용 중인 웹사이트 주소를 입력하거나 붙여넣어 공식 도메인인지 확인하십시오.',
            verifyPlatform: '확인 플랫폼',
            finalWarning:
                '가짜 사이트를 이용하면 계정이 도용되거나 자금 손실이 발생할 수 있으며, 회사는 책임을 지지 않습니다!',
            verifyNow: '바로 확인',
            close: '닫기',
            closeCountdown: '닫기 ({n}s)'
        },
        prompt: {
            networkerror: '현재 네트워크가 좋지 않습니다. 다시 시도해 주세요.',
            networkoffline: '네트워크에 연결되어 있지 않습니다',
            networkreconnecting: '연결이 끊어졌습니다. 다시 연결 중...',
            networkrecovered: '네트워크가 복구되었습니다',
            sessionexpired: '세션이 만료되었습니다',
            wsrelogin:
                '네트워크 연결에 이상이 발생했습니다. 시스템에 다시 로그인해 주세요. 감사합니다!',
            inactive:
                '오랫동안 활동하지 않으셨습니다. 계속하려면 다시 로그인해 주세요.',
            // betting  prompt
            // d7error: '35라운드 이후에는 드래곤 7을 베팅할 수 없습니다.',
            // b8error: '35라운드 이후에는 베어 8을 베팅할 수 없습니다.',
            // bigtigererror: '50라운드 이후에는 빅 타이거를 베팅할 수 없습니다.',
            // smalltigererror:
            //     '50라운드 이후에는 스몰 타이거를 베팅할 수 없습니다.'
            d7error: '35局以后不可下注龙7',
            b8error: '35局以后不可下注熊8',
            bigtigererror: '35局以后不可下注大老虎',
            smalltigererror: '35局以后不可下注小老虎'
        }
    }
}

const i18n = createI18n({
    legacy: false,
    locale: getCookieValue(Token.LANG) || getBrowserLanguage(),
    fallbackLocale: 'zh',
    globalInjection: true,
    warnHtmlInMessage: false,
    warnHtmlMessage: false,
    messages
})

export default i18n
